import { isEmpty } from './is-empty.util';

const HTML_TAG_PATTERN =
  /<\/?(?:p|br|div|span|ol|ul|li|strong|em|b|i|u|a|s|sub|sup|pre|code|blockquote|h[1-6])(?=[\s>/])[^>]*\/?>/gi;

// Matches strings composed entirely of empty <p> tags, optional <br> tags, and whitespace
const EMPTY_HTML_PATTERN = /^(\s|<p>(\s|<br\/?>)*<\/p>)*$/i;

export const formatEditorString = (note?: string) =>
  note ? note.replace(HTML_TAG_PATTERN, '') : '';

export const cleanEditorText = (text: string): string => {
  const formattedText = formatEditorString(text);

  return isEmpty(formattedText) ? formattedText : text;
};

export function sanitizeEmptyContent(content: string): string {
  if (isEmpty(content) || EMPTY_HTML_PATTERN.test(content)) {
    return '';
  }

  return content;
}
